import { useEffect } from 'react'

// TODO: The way the shortcuts are implemented, they're on the global window
// object, meaning when a modal is open on top of another one, all modals
// are closed from one click. I need to come up with some way to scope the
// events and give the hook a specific dom node to attach to.

export function useKeyShortcut(opt: {
    key: string
    callback: () => void
    modifier?: "ctrl"

    /**
     * Set to true if you need to dynamically toggle the shortcut
     */
    disabled?: boolean
}) {

    useEffect(() => {

        const handleKeydown = (e: KeyboardEvent) => {
            const pressedKey = e.key.toLowerCase()
            const targetKey = opt.key.toLowerCase()

            const doClick = () => {
                if (opt.disabled && opt.disabled === true) {
                    return
                }

                e.preventDefault()
                opt.callback()
            }

            if (pressedKey === targetKey) {

                if (opt.modifier != null) {

                    if (e.ctrlKey && opt.modifier === "ctrl") {
                        doClick()
                    }

                } else {
                    doClick()
                }

            }
        }

        window.addEventListener('keydown', handleKeydown)

        return () => {
            window.removeEventListener('keydown', handleKeydown)
        }

    }, [opt])
}
